export type SubmitAgentVerificationFormProps = {
  firstName: string
  lastName: string
  email: string
  dateOfBirth: string
  validationInviteId: string
  organisationId: string
}

export const AgentVerificationStatus = {
  Success: 'success',
  Pending: 'pending',
  Error: 'error',
  CannotDetermine: 'cannot_determine'
} as const

export type AgentVerificationStatus = typeof AgentVerificationStatus[keyof typeof AgentVerificationStatus]

export type AgentVerificationResult = {
  data: {
    id: string
    validationInviteId: string
    isEligible?: boolean
    checkStatus: AgentVerificationStatus
  }
}
